import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import MauvelousPrimaryButton from "../../common/button/mauvelousPrimaryButton";
import { useNavigate, useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";
import AddorUpdateCategoryDocument from "./AddorUpdateDocument";
import CapcategoryTable from "./CategoryDocumentTable";



export default function Index() {
  const naviagte = useNavigate();
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page");
console.log(page,'page')
 

  return (
    <Grid
      p={page ===  3}
      sx={{
        minHeight: "50vh",
        backgroundColor:
           "#fff",
        borderRadius: "8px",
        p:2
      }}
    >
      {page === "category-documentlist" && (
        <Grid container >
          <Grid
            item
            md={12}
            sx={{ display: "flex", justifyContent: "flex-end", py:1 }}
          >
            <MauvelousPrimaryButton
              title={"Add Cap Category Document"}
              handleClick={() =>
                naviagte(
                  `/${Cookies.get(
                    "mhet_mst_project"
                  )}/cap-category-document?page=addcapcategorydocument`
                )
              }
            />
          </Grid>
          <Grid item md={12}>
            <CapcategoryTable />
          </Grid>
        </Grid>
      )}
      {page === "addcapcategorydocument" && <AddorUpdateCategoryDocument />}
      {page === "updatecapcategorydocument" && <AddorUpdateCategoryDocument />}
    </Grid>
  );
}
